// extracted by mini-css-extract-plugin
module.exports = {"root":"header-profile_root__jRN_0"};